import React from "react";
import { IoCalendar, IoCheckmark } from "react-icons/io5";
import { TbSunrise } from "react-icons/tb";

import SimpleButton from "@/components/Buttons/SimpleButton";
import {
  CardRow,
  CardRowActions,
  CardRowCell,
  CardRowCells,
  CardRowDivider,
} from "@/components/CardRow";
import PowerPlantNameDisplay from "@/components/PowerPlantNameDisplay";
import { formatDateIgnoringTimezone } from "@/utils/dateFormater";

import { PercentageLetterCardProps } from "./types";

const PercentageLetterCard: React.FC<PercentageLetterCardProps> = ({
  name,
  startDate,
  active,
  shared,
  onClick,
}) => {
  return (
    <CardRow className="!overflow-visible">
      <CardRowCells
        divider={false}
        className="grid min-w-[760px] grid-cols-[280px_1px_240px_1px_190px] items-center gap-x-4"
      >
        <CardRowCell
          label="NOME DA SPE"
          value={name}
          icon={<TbSunrise />}
          renderValue={(value) => <PowerPlantNameDisplay name={String(value)} />}
          rightContent={
            shared && (
              <div className="group relative shrink-0">
                <div
                  className="flex size-6 cursor-help items-center justify-center rounded-full bg-success200 text-sm font-bold text-black"
                  aria-label="Essa carta é compartilhada"
                >
                  !
                </div>
                <div className="pointer-events-none absolute bottom-full left-1/2 z-30 mb-2 hidden w-max -translate-x-1/2 rounded-lg bg-black px-3 py-2 text-sm text-white shadow-lg group-hover:block">
                  Essa carta é compartilhada
                </div>
              </div>
            )
          }
        />
        <CardRowDivider />
        <CardRowCell
          label="DATA DE INÍCIO"
          value={formatDateIgnoringTimezone(startDate)}
          icon={<IoCalendar />}
        />
        <CardRowDivider />
        <CardRowCell
          label="STATUS"
          icon={<IoCheckmark />}
          status={{ label: active ? "Ativo" : "Inativo", tone: active ? "success" : "danger" }}
        />
      </CardRowCells>
      <CardRowActions className="details-button">
        <SimpleButton variant="simple" label="Detalhes" onClick={onClick} />
      </CardRowActions>
    </CardRow>
  );
};

export default PercentageLetterCard;
